<template>
  <InArticleAdsense
    class="RwvContentAd"
    :data-ad-client="data.ad_client"
    :data-ad-slot="data.ad_slot"
    data-ad-test="on">
  </InArticleAdsense>
</template>

<script>

export default {
  name: "RwvContentAd",
  components: {

  },
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  }
};
</script>
<style lang="scss">
.RwvContentAd {
  overflow: hidden;
}
</style>

